(function () {
  const WHATSAPP_NUMBER = "905362330502"; // +90 536 233 05 02

  const CART_MESSAGE_HEADER =
    "Merhaba KHL Boutique, seçtiğim parçalar için Fatih randevusu istiyorum.\n\n";

  const PRODUCT_MESSAGE_HEADER =
    "Merhaba KHL Boutique, bu parça için özel randevu istiyorum.\n\n";

  /* -----------------------------
   * Helpers
   * ----------------------------- */
function openWhatsApp(message) {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  // iOS için direkt yönlendirme
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    window.location.href = url;
  } else {
    window.open(url, "_blank");
  }
}


  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Cart fetch failed");
    return await res.json();
  }

  function formatCartLineItem(item) {
    const title = item.product_title || item.title || "Ürün";
    const variant =
      item.variant_title && item.variant_title !== "Default Title"
        ? ` (${item.variant_title})`
        : "";
    const qty = item.quantity || 1;

    // Shopify cart.js item.url -> ürün yolu (çoğunlukla variant içerir)
    const productUrl = `${window.location.origin}${item.url}`;

    return `• ${title}${variant} x${qty}\n${productUrl}`;
  }

  function buildCartMessage(cart) {
    const lines = (cart.items || []).map(formatCartLineItem);
    const cartNote = cart.note ? `\nNot: ${cart.note}\n` : "";

    return (
      CART_MESSAGE_HEADER +
      (lines.length ? lines.join("\n\n") : "• Sepet boş görünüyor.") +
      cartNote
    );
  }

  async function handleWhatsAppCartOrderClick() {
    try {
      const cart = await getCart();
      openWhatsApp(buildCartMessage(cart));
    } catch (e) {
      openWhatsApp(CART_MESSAGE_HEADER + "Sepet detaylarını paylaşmak istiyorum.");
    }
  }

  /* -----------------------------
   * CART: Hide checkout + add WA button
   * ----------------------------- */
  function injectCartButton() {
    const checkoutBtn = document.querySelector(
      'button#checkout[name="checkout"], button#checkout, button[name="checkout"], form[action*="/checkout"] [type="submit"]'
    );
    if (!checkoutBtn) return;

    checkoutBtn.style.display = "none";

    if (document.querySelector("#whatsapp-checkout")) return;

    const waBtn = document.createElement("button");
    waBtn.type = "button";
    waBtn.id = "whatsapp-checkout";
    waBtn.className = checkoutBtn.className;
    waBtn.textContent = "WhatsApp ile randevu";
    waBtn.addEventListener("click", handleWhatsAppCartOrderClick);

    checkoutBtn.parentNode.insertBefore(waBtn, checkoutBtn.nextSibling);
  }

  /* -----------------------------
   * PRODUCT: Add WA button next to Add to Cart
   * ----------------------------- */
  function findProductForm() {
    // En yaygın: action="/cart/add"
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getProductTitle() {
    const el =
      document.querySelector("h1") ||
      document.querySelector('[data-product-title]') ||
      document.querySelector(".product__title");
    return el ? el.textContent.trim() : "Ürün";
  }

  function getSelectedQty(form) {
    const qtyEl =
      form.querySelector('[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');

    const qty = qtyEl ? parseInt(qtyEl.value || "1", 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getSelectedVariantId(form) {
    // 1) URL paramı varsa öncelik ver
    const url = new URL(window.location.href);
    const v = url.searchParams.get("variant");
    if (v) return v;

    // 2) form içinde name="id"
    const idEl = form.querySelector('[name="id"]') || document.querySelector('[name="id"]');
    return idEl ? idEl.value : null;
  }

  function getProductUrlWithVariant(variantId) {
    const u = new URL(window.location.href);
    if (variantId) u.searchParams.set("variant", variantId);
    return u.toString();
  }

  async function fetchVariantTitle(variantId) {
    try {
      const path = window.location.pathname; // /products/handle
      if (!path.includes("/products/")) return "";

      const handle = path.split("/products/")[1]?.split("/")[0];
      if (!handle) return "";

      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return "";

      const product = await res.json();
      const v = (product.variants || []).find(
        (x) => String(x.id) === String(variantId)
      );
      if (!v) return "";

      const t = (v.public_title || v.title || "").trim();
      return t && t !== "Default Title" ? t : "";
    } catch {
      return "";
    }
  }

  async function handleWhatsAppProductOrderClick(form) {
    const title = getProductTitle();
    const qty = getSelectedQty(form);
    const variantId = getSelectedVariantId(form);

    let variantTitle = "";
    if (variantId) variantTitle = await fetchVariantTitle(variantId);

    const productUrl = getProductUrlWithVariant(variantId);

    const msg =
      PRODUCT_MESSAGE_HEADER +
      `• ${title}${variantTitle ? ` (${variantTitle})` : ""} x${qty}\n` +
      productUrl;

    openWhatsApp(msg);
  }

  function injectProductWhatsAppButton() {
    const form = findProductForm();
    if (!form) return;

    // Senin temadaki buton id pattern’i:
    // id="BuyButtons-ProductSubmitButton-...__add-to-cart"
    const addBtn =
      form.querySelector('button[name="add"][type="submit"][id^="BuyButtons-ProductSubmitButton-"]') ||
      form.querySelector('button[type="submit"][name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('[type="submit"]');

    if (!addBtn) return;

    if (document.querySelector("#whatsapp-product-order")) return;

    const waBtn = document.createElement("button");
    waBtn.type = "button";
    waBtn.id = "whatsapp-product-order";
    waBtn.className = addBtn.className; // aynı stil
    waBtn.textContent = "WhatsApp ile randevu";
    waBtn.style.marginLeft = "10px";

    waBtn.addEventListener("click", () => handleWhatsAppProductOrderClick(form));

    addBtn.insertAdjacentElement("afterend", waBtn);
  }

  /* -----------------------------
   * Boot
   * ----------------------------- */
  function runAllInjectors() {
    injectCartButton();
    injectProductWhatsAppButton();
  }

  document.addEventListener("DOMContentLoaded", runAllInjectors);

  // Cart drawer / product component dynamic render
  const obs = new MutationObserver(() => runAllInjectors());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
